{
  "menu": {
    "home": "홈",
    "programs": "프로그램",
    "residency": "영주권",
    "citizenship": "여권 및 시민권",
    "about": "회사 소개",
    "aboutShort": "소개",
    "partnership": "파트너십",
    "education": "교육",
    "news": "인사이트",
    "contact": "문의"
  },
  "footer": {
    "copyright": "© 2026 Pacific Link International. All rights reserved.",
    "abn": "Australia · ABN 99 673 671 184",
    "quickLinks": "바로가기",
    "immigrationSite": "이민 프로그램",
    "educationSite": "온라인 학위 프로그램",
    "legal": "법적 정보",
    "legalNotice": "법적 고지",
    "privacyPolicy": "개인정보 처리방침",
    "termsOfUse": "이용약관"
  }
}
